<template>
  <div class="success">
    <template v-if="authStore.isPro">
      <h1>{{ $t('You are on Pro') }}</h1>
      <p>{{ $t('Saving and reports are now enabled in every program.') }}</p>
      <router-link to="/" class="btn">{{ $t('Go to the programs') }}</router-link>
    </template>
    <template v-else-if="gaveUp">
      <h1>{{ $t('Payment received') }}</h1>
      <p>{{ $t('Your plan is being activated. It can take a minute; reload this page or open the programs.') }}</p>
      <router-link to="/" class="btn">{{ $t('Go to the programs') }}</router-link>
    </template>
    <template v-else>
      <h1>{{ $t('Activating your plan...') }}</h1>
      <p>{{ $t('Waiting for the payment service to confirm.') }}</p>
    </template>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useAuthStore } from '../stores/auth'

const authStore = useAuthStore()
const gaveUp = ref(false)
let timer = null
let tries = 0

const check = async () => {
  tries += 1
  try {
    await authStore.fetchUser()
  } catch (err) {
    // keep trying: the confirmation may simply not have arrived yet
  }
  if (authStore.isPro) return
  if (tries >= 20) {
    gaveUp.value = true
    return
  }
  timer = setTimeout(check, 2000)
}

onMounted(check)
onBeforeUnmount(() => clearTimeout(timer))
</script>

<style scoped>
.success {
  padding: 60px 20px;
  text-align: center;
}

.btn {
  display: inline-block;
  margin-top: 16px;
  padding: 10px 18px;
  border-radius: 6px;
  background: #4CAF50;
  color: white;
  text-decoration: none;
}
</style>
